const setTransactionHeader = (meUserSettings, currentCompanyId) => {
  const userSettings = [];
  meUserSettings.forEach((userSetting) => {
    if (userSetting.companyId === currentCompanyId) {
      userSettings.push(userSetting);
    }
  });
  if (userSettings[0].transactionScreenColumnSelection) {
    localStorage.setItem('transactionHeader', userSettings[0].transactionScreenColumnSelection);
  }
  return userSettings;
};
/**
     * Returns parent company id
     * @param {*} meCompanyList
     * @param {*} currentCompany
     * @returns parentCompany
     */
const getParentCompany = (meCompanyList, currentCompany) => {
  let parentCompany = currentCompany;
  meCompanyList.forEach((company) => {
    if (company.id === currentCompany) {
      parentCompany = company.parentCompany ? company.parentCompany.id : currentCompany;
      if (company.isParent) {
        parentCompany = company.id;
      }
    }
  });
  return parentCompany;
};

/**
     * Returns list of companies based on parentCompanyId.
     * @param {*} meCompanyList
     * @param {*} parentCompany
     * @returns companyList
     */
const getCompanyListBasedOnParent = (meCompanyList, parentCompany) => {
  const companyList = [];
  meCompanyList.forEach((company) => {
    if (company.id === parentCompany) {
      companyList.push(company.id);
    }

    if (company.parentCompany) {
      if (company.parentCompany.id === parentCompany) {
        companyList.push(company.id);
      }
    }
  });
  return companyList;
};

export {
  setTransactionHeader,
  getParentCompany,
  getCompanyListBasedOnParent,
};
